import { element, func, oneOfType, string } from 'prop-types';
import React, { Component } from 'react';

import BaseModal from './BaseModal.js';

// Wrapper for BaseModel
// Renders prop `label` in a Button.
// Clicking the button opens the modal, with its children as the content.
// passes all props (except isOpen) to BaseModal
export default class BaseModalButton extends Component {
  state = { isOpen: false };

  onOpenModal = () => {
    this.setState({ isOpen: true });
  };

  onCloseModal = () => {
    this.setState({ isOpen: false });
    if (this.props.close) {
      this.props.close();
    }
  };

  render() {
    const { isOpen } = this.state;
    const { buttonClassName, children, label, modalClassName } = this.props;
    const baseModalProps = {
      hideAnchor: true,
      ...this.props,
      className: modalClassName,
      close: this.onCloseModal,
      isOpen
    };

    return (
      <div>
        <button className={buttonClassName} onClick={this.onOpenModal}>
          {label}
        </button>
        <BaseModal {...baseModalProps}>{children}</BaseModal>
      </div>
    );
  }
}

BaseModalButton.propTypes = {
  buttonClassName: string,
  close: func,
  modalClassName: string,
  label: oneOfType([element, string]).isRequired
  // Any BaseModal props, see ./BaseModal.js
};
